<template>
  <div>
    <Header />
    <div
      id="wrapper"
      class="booking-process"
      aria-busy="false"
      style="position: relative"
    >
      <div class="main only-hotel">
        <span class="js-mobile-navigation--accommodation-avail"></span>
        <div
          id="accommodation-avail:c-mobile-navigation"
          class="c-mobile-navigation c-mobile-navigation--accommodation-avail"
        >
          <div
            class="c-mobile-navigation-bar c-mobile-navigation-bar--top u-display--block u-display--none@md"
          >
            <div class="c-mobile-navigation-content-wrapper">
              <div class="c-navigation-availability">
                <a
                  href="/home?tripId=2"
                  class="c-navigation-availability__square"
                >
                  <i class="fa-regular fa-arrow-left"></i
                ></a>
                <div class="c-navigation-availability__text">
                  <div class="c-navigation-availability-title">
                    <small class="c-navigation-availability-title__small"
                      >Accommodations</small
                    ><b class="c-navigation-availability-title__medium"
                      >in Florida Keys FL</b
                    >
                  </div>
                </div>
                <div
                  data-target="#composeModal"
                  data-toggle="modal"
                  class="c-navigation-availability__edit"
                >
                  <i class="fa-regular fa-magnifying-glass"></i>
                </div>
              </div>
            </div>
          </div>
          <div
            class="c-mobile-navigation-bar c-mobile-navigation-bar--bottom u-display--block u-display--none@md"
          >
            <div class="c-mobile-navigation-content-wrapper">
              <div
                id="accommodation-avail:hotel-view-buttons-mobile"
                class="c-navigation-availability__button-group hotel-view-buttons"
              >
                <div
                  class="c-navigation-availability__button dev-availability-filters"
                >
                  <a
                    class="c-button u-min-width--auto bdr-clr--brand u-1/1 ux-open-filters u-font-size--small u-font-size--default@sm"
                    @click="openFiltersTab()"
                    ><span>{{ $func.parseIso("filters") }}</span
                    ><i class="fa-regular fa-sliders-h ml-10"></i
                  ></a>
                </div>
                <!-- <div class="c-navigation-availability__button">
                  <a
                    id="accommodation-avail:j_id_3t"
                    href="#"
                    class="ui-commandlink ui-widget c-button u-min-width--auto u-1/1 u-font-weight--700"
                    aria-label=""
                    style="
                      background-image: url('https://booking.vacancyrewards.com/javax.faces.resource/images/btn-map.png');
                    "
                  >
                    <i
                      class="fa-solid fa-map-marker-alt u-font-size--big clr--brand"
                    ></i
                  ></a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="container o-container o-container--large">
          <div class="o-layout" style="display: flex">
            <!-- Filters -->
            <ResortListFilters
              :country="country"
              :city="city"
              :state="state"
              :checkIn="checkIn"
              :checkOut="checkOut"
              :token="token"
              @edit-search="openEditSearch"
            />
            <!-- Fin Filter -->
            <div
              class="o-layout__item u-12/12 u-9/12@md pl-0 pl-20@md pl-40@lg comp-app"
            >
              <form
                id="mainForm"
                name="mainForm"
                method="post"
                action="/accommodation/onlyAccommodationAvail.xhtml?tripId=2&amp;availPosition=1"
                onkeypress="return event.keyCode != 13;"
                enctype="application/x-www-form-urlencoded"
                data-partialsubmit="true"
              >
                <div
                  id="mainForm:hotelMapModal"
                  class="c-modal hotelMapModal c-modal--onmobile-fullscreen setup-modal-back-button"
                  data-size="large"
                  role="dialog"
                  data-closeable="true"
                  tabindex="-1"
                  aria-modal="true"
                  data-active="false"
                >
                  <div
                    class="c-modal__backmask"
                    onclick="$('.hotelMapModal').modal('hide')"
                  ></div>
                  <div class="c-modal__wrapper">
                    <div class="c-modal__container">
                      <div class="c-modal__close" style="">
                        <button
                          type="button"
                          class="c-modal__close-btn"
                          data-dismiss="modal"
                        >
                          <span
                            class="o-box--small--horizontal o-box--tiny--vertical u-font-weight--500 u-font-size--small u-border-radius--sm u-line-height--1 u-pointer-events--none"
                          >
                            Close
                            <i
                              class="fa-solid fa-caret-right u-font-size--default"
                            ></i></span
                          ><i class="u-display--block fa-regular fa-close"></i>
                        </button>
                      </div>
                      <div class="c-modal__body">
                        <div
                          class="c-modal__header u-font-weight--600 u-line-height--1 u-hide-empty"
                        ></div>
                        <div class="hotelDataSheet">
                          <div class="c-microservice c-microservice--hotel-map">
                            <div class="c-microservice__primary">
                              <div
                                class="c-microservice__main p-0 u-border--none"
                              >
                                <div class="c-microservice__body">
                                  <div class="c-microservice__content">
                                    <a
                                      href="/accommodation//waiting/1?tripId=2&amp;previousPage=%2Faccommodation%2FonlyAccommodationAvail.xhtml&amp;previousViewState=NDNhYjQ4MzMzNTIzOTQ3MjAwMDAwMDAy"
                                      id="mainForm:openHotelMiniMap"
                                      name="mainForm:openHotelMiniMap"
                                      target="_blank"
                                    >
                                      <div class="c-microservice__heading">
                                        <b
                                          class="c-microservice__title mt-5"
                                        ></b>
                                        <div class="c-hotel-status null mt-5">
                                          <span
                                            class="c-hotel-status__category null"
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                            ><i
                                              class="fa-solid fa-key c-hotel-status__star"
                                            ></i
                                          ></span>
                                        </div>
                                      </div>
                                      <div
                                        class="c-microservice__details"
                                      ></div>
                                    </a>
                                  </div>
                                </div>
                                <div class="c-microservice__map-section">
                                  <div
                                    style="height: 500px"
                                    class="c-microservice__map c-microservice__map--lg"
                                    data-marker-target="_blank"
                                    data-availposition="1"
                                    data-hotelname=""
                                    data-market-feature="true &amp;&amp; !isInIframe() ? '' : travelc.pushViewStateToHistory()"
                                    data-marker-link="/accommodation/accommodationDetailWaiting.xhtml?tripId=2&amp;availPosition=1&amp;accommodationCode=&amp;previousPage=/accommodation/onlyAccommodationAvail.xhtml&amp;previousViewState=NDNhYjQ4MzMzNTIzOTQ3MjAwMDAwMDAy"
                                    data-latitude=""
                                    data-is-apartment=""
                                    data-longitude=""
                                    data-code=""
                                  >
                                    <div id="hotel-map-container"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="mainForm:hoteles"
                  class="ux-service-city-availability ux-service-city-availability--hotel o-block o-block--small parent-clr--1"
                >
<div class="aviso-no-disponible" v-if="avisoNoDisponible" role="status">
                  <i class="fa-regular fa-circle-info"></i>
                  <span>{{ $func.parseIso("weekNoLongerAvailable").replace("{resort}", avisoNoDisponible) }}</span>
                </div>
<div
                  id="mainForm:sort-selector"
                  class="rbar"
                >
                    <div class="rcnt">
                      <strong>{{ totalList }} resorts</strong> {{ $func.parseIso("availableIn") }}
                      {{ city === "all" ? $func.parseIso("allCity") : city }}{{ state && state !== "" ? ", " + state : "" }}{{ country ? ", " + country : "" }}
                      · {{ formatNate(checkIn) }} - {{ formatNate(checkOut) }}
                    </div>
                    <div class="sort-wrap">
                      <button
                        type="button"
                        class="share-btn"
                        :disabled="loading"
                        @click="compartirBusqueda"
                      >
                        <i class="fa-regular fa-link"></i>
                        {{ $func.parseIso("shareSearch") }}
                      </button>
                      <span class="sort-lbl">{{ $func.parseIso("orderBy") }}</span>
                      <div
                        :class="`c-dropdown dropdown clr--dark-gray sort-selector ${
                          openListSort ? 'open' : ''
                        }`"
                      >
                        <a
                          id="sortHotelsButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="true"
                          class="c-button dropdown-toggle ux-sort-selector sortHotelsButton sort-sel"
                          @click="openListSort = !openListSort"
                          ><span
                            class="o-flexbox u-align-items--center u-min-width--auto u-gap--tiny u-font-weight--600 u-white-space--nowrap"
                            >{{
                              selectSort
                                ? $func.parseIso(selectSort.nameIso)
                                : "n/a"
                            }} </span
                          ><i
                            class="fa-regular fa-angle-down u-font-size--big"
                            aria-hidden="true"
                          ></i
                        ></a>
                        <div
                          class="dropdown-menu o-box--default"
                          aria-labelledby="sortHotelsButton"
                        >
                          <div class="o-block o-block--small">
                            <div
                              class="o-block__item"
                              v-for="(l, idx) in listSort"
                              :key="idx"
                            >
                              <a
                                id="mainForm:j_id_4o3:dropdown:sortByPopularity"
                                class="ui-commandlink ui-widget u-display--block o-box--tiny--vertical u-padding--null@sm sortByPopularity"
                                @click="setSort(l.id, true)"
                                style="cursor: pointer"
                              >
                                <span
                                  :class="`${
                                    selectSort && l.id === selectSort.id
                                      ? 'u-font-weight--bold'
                                      : ''
                                  }`"
                                >
                                  {{ $func.parseIso(l.nameIso) }}
                                </span></a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    id="mainForm:hotelsInfo"
                    class="hotelsInfo dev-hotels-info"
                  >
                    <span
                      class="call-pp-help"
                      data-target-pp="#linkList"
                      data-content="Search results in a list - 1"
                      data-placement="top"
                      data-search-parent="true"
                    ></span
                    ><span
                      class="call-pp-help"
                      data-target-pp=".linkMap"
                      data-content="Search results in a map - 2"
                      data-placement="bottom"
                      data-search-parent="true"
                    ></span
                    ><span
                      class="call-pp-help"
                      data-target-pp=".ui-paginator-pages .ui-paginator-page:lt(3):last"
                      data-content="See more accommodations - 3"
                      data-placement="top"
                      data-search-parent="true"
                    ></span
                    ><span
                      class="call-pp-help"
                      data-target-pp=".select-hotel:lt(1):last"
                      data-content="Select this hotel - 4"
                      data-placement="bottom"
                      data-search-parent="true"
                    ></span
                    ><span
                      class="call-pp-help"
                      data-target-pp=".c-extended__button--details:first"
                      data-content="Show selected hotel info and rooms - 5"
                      data-placement="left"
                      data-search-parent="true"
                    ></span>
                    <div class="o-block">
                      <div
                        class="o-block__item u-display--none u-display--block@md"
                      >
                      </div>
                      <div class="o-block o-block--tiny o-block__item">
                        <div
                          id="mainForm:j_id_4py_aw:remove-filter-list"
                          class="remove-filter-list"
                        ></div>
                      </div>
                      <div
                        id="mainForm:hotelViews"
                        class="o-block__item hotelViews"
                      >
                        <div
                          id="mainForm:horizontalFichas"
                          class="horizontalFichas"
                        >
                          <div
                            id="mainForm:datascrollHorizontal"
                            class="ui-dataview ui-widget pf-dataListPaginator ux-options-service ui-dataview-grid"
                          >
                            <!-- Item -->
                            <ResortListItem
                              v-show="loading"
                              v-for="(weekl, ida) in weeksLoading"
                              :week="weekl"
                              :key="`${ida}loading`"
                              :token="token"
                            />
                            <ResortListItem
                              v-show="!loading"
                              v-for="(week, idx) in weeks"
                              :week="week"
                              :key="idx"
                              :token="token"
                            />
                            <!-- Fin Item -->

                            <!-- Pagiante -->
                            <ResortListPaginate
                              :actualPage="page"
                              :totalPage="totalPage"
                              :total="totalList"
                              :limit="limit"
                              :country="country"
                              :city="city"
                              :checkIn="checkIn"
                              :checkOut="checkOut"
                              :token="token"
                            />
                            <!-- Fin Paginate -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <Footer :isDefault="club && false" :club="club" /> -->

    <modal
      name="edit-search"
      :width="1080"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      classes="edit-search-modal"
    >
      <div class="edit-search-modal__head">
        <span class="edit-search-modal__title">{{ $func.parseIso("editSearch") }}</span>
        <button class="edit-search-modal__close" type="button" @click="closeEditSearch">
          <i class="fa-regular fa-close"></i>
        </button>
      </div>
      <div class="edit-search-modal__body">
        <SearchForm
          :btnColor="btnColor"
          :embedded="true"
          @search="submitEditSearch"
        />
      </div>
    </modal>
    <ShareLinkModal />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";

import ResortListItem from "../components/ResortList/ResortListItem.vue";
import ResortListFilters from "../components/ResortList/ResortListFilters.vue";
import ResortListPaginate from "../components/ResortList/ResortListPaginate.vue";
import SearchForm from "../components/SearchForm.vue";
import ShareLinkModal from "../components/ShareLinkModal.vue";

import { linkBusqueda, PARAMS_COMPARTIBLES } from "../utils/compartir";
import {
  getSearchWeekObject,
  getTokenTC,
  setSearchWeekObject,
  setSortWeeksObject,
  getSortWeeksObject,
  getClubObject,
  removeBookingTimer,
  removeSelectedUnit,
  removeHoldNumberRef,
  removeTravelerData,
} from "../utils/sesions";
import { optionTokens } from "../utils/holidayTags";

export default {
  components: {
    Header,
    Footer,
    ResortListItem,
    ResortListFilters,
    ResortListPaginate,
    SearchForm,
    ShareLinkModal,
  },
  // props: ["items"],
  provide() {
    // Cada tarjeta arma el link de su resort con la búsqueda y el orden actuales
    return {
      linkResortCompartido: (week) =>
        linkBusqueda(this.busquedaActual(), { sortId: this.selectSort?.id, resort: week.ResortName }),
    };
  },
  data() {
    const weeksLoading = [
      {
        ResortName: this.$func.parseIso("loadingResortName") + "...",
        KitchenType: "n/a",
        UnitType: "n/a",
        Cost: "0.00 ...",
        CheckInDate: null,
        CheckOutDate: null,
        ResortAddress1: "",
        ResortAddress2: "",
        ResortAddress3: "",
        ResortCity: "",
        ResortState: "",
        ResortCountry: "",
        InvTypeInDetail: null,
        Amenities: [],
        Rating: 0,
        imgs: [
          "https://www.downgraf.com/wp-content/uploads/2019/05/Loader-animation-principle-freebie.gif",
        ],
      },
      {
        ResortName: this.$func.parseIso("loadingResortName") + "...",
        KitchenType: "n/a",
        UnitType: "n/a",
        Cost: "0.00 ...",
        CheckInDate: null,
        CheckOutDate: null,
        ResortAddress1: "",
        ResortAddress2: "",
        ResortAddress3: "",
        ResortCity: "",
        ResortState: "",
        ResortCountry: "",
        InvTypeInDetail: null,
        Amenities: [],
        Rating: 0,
        imgs: [
          "https://www.downgraf.com/wp-content/uploads/2019/05/Loader-animation-principle-freebie.gif",
        ],
      },
    ];

    return {
      weeks: [],
      weeksLoading: [...weeksLoading, ...weeksLoading, ...weeksLoading],
      country: null,
      city: null,
      checkIn: null,
      checkOut: null,
      token: null,
      club: null,
      iso: null,
      page: 1,
      limit: 10,
      totalPage: 1,
      totalList: 0,
      loading: true,
      checkFilters: null,
      btnColor: null,
      listSort: [
        {
          nameIso: "priceLowest",
          value: { Cost: 1 },
          id: 1,
        },
        {
          nameIso: "priceHighest",
          value: { Cost: -1 },
          id: 2,
        },
        {
          nameIso: "checkInOrderHighest",
          value: { CheckInDate: -1 },
          id: 3,
        },
        {
          nameIso: "checkInOrderLowest",
          value: { CheckInDate: 1 },
          id: 4,
        },
        {
          nameIso: "ratingOrderHighest",
          value: { Rating: -1 },
          id: 5,
        },
        {
          nameIso: "ratingOrderLowest",
          value: { Rating: 1 },
          id: 6,
        },
      ],
      selectSort: null,
      openListSort: false,
      weekType: null,
      occupancy: null,
      capacity: null,
      kitchen: null,
      cityFilter: null,
      priceMin: null,
      priceMax: null,
      rating: null,
      holiday: null,
      resort: null,
      avisoNoDisponible: null,
    };
  },
  async created() {
    this.clearBookingState();
    // await this.checkSesion();
    await this.checkParams();

    // El listado normal nunca regresa a Holiday Weeks: apaga el flag de origen
    sessionStorage.removeItem("holidaylist");

    const tmpSort = await getSortWeeksObject();
    if (!tmpSort) await this.setSort(1);
    else {
      this.selectSort = tmpSort;
    }

    await this.listWeeks();

    const __club = getClubObject();
    if (__club?.ColorPrimarioHex) this.btnColor = __club.ColorPrimarioHex;

    this.iso = localStorage.getItem("iso");
    this.$moment.locale(this.iso);
    this._onChangeIso = () => {
      this.iso = localStorage.getItem("iso");
      this.$moment.locale(this.iso);
      this.$forceUpdate();
    };
    this._onChangePage = async () => {
      this.loading = true;
      window.scrollTo(0, 0);
      await this.checkParams();
      await this.listWeeks();
      this.$forceUpdate();
    };
    this._onChangeFilter = async () => {
      this.loading = true;
      window.scrollTo(0, 0);
      await this.checkParams();
      await this.listWeeks();
      this.$forceUpdate();
    };
    this._onSetSort = async (s) => {
      await this.setSort(s, true);
      this.$forceUpdate();
    };
    this.$bus.on("change-iso", this._onChangeIso);
    this.$bus.on("change-page", this._onChangePage);
    this.$bus.on("change-filter", this._onChangeFilter);
    this.$bus.on("set-sort", this._onSetSort);
  },
  beforeDestroy() {
    this.$bus.off("change-iso", this._onChangeIso);
    this.$bus.off("change-page", this._onChangePage);
    this.$bus.off("change-filter", this._onChangeFilter);
    this.$bus.off("set-sort", this._onSetSort);
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    clearBookingState() {
      removeBookingTimer();
      removeSelectedUnit();
      removeHoldNumberRef();
      removeTravelerData();
    },
    openEditSearch() {
      this.$modal.show("edit-search");
    },
    closeEditSearch() {
      this.$modal.hide("edit-search");
    },
    submitEditSearch(payload) {
      setSearchWeekObject({
        country: payload.country,
        city: payload.city,
        state: payload.state,
        checkIn: payload.checkIn,
        checkOut: payload.checkOut,
        page: 1,
        limit: 10,
      });
      this.$modal.hide("edit-search");
      this.$bus.emit("change-filter");
    },
    formatNate(date) {
      if (!date) return "";
      return this.$moment(date).format("LL");
    },
    async checkParams() {
      // console.log(this.$route.query)

      const token = getTokenTC();
      this.token = token;

      const searchWeek = getSearchWeekObject(this.$route.query);

      if (!searchWeek) this.$router.push("/");

      const {
        country,
        state,
        city,
        checkIn,
        checkOut,
        page,
        limit,
        type,
        occupancy,
        capacity,
        kitchen,
        resort,
        cityFilter,
        priceMin,
        priceMax,
        rating,
        holiday,
      } = searchWeek;

      this.country = country || null;
      this.state = state || null;
      this.city = city || null;
      this.checkIn = checkIn || null;
      this.checkOut = checkOut || null;
      this.page = page || 1;
      this.limit = limit || 10;
      this.weekType = type || null;
      this.occupancy = occupancy || null;
      this.capacity = capacity || null;
      this.kitchen = kitchen || null;
      this.resort = resort || null;
      this.cityFilter = cityFilter || null;
      this.priceMin = priceMin != null && priceMin !== "" ? priceMin : null;
      this.priceMax = priceMax != null && priceMax !== "" ? priceMax : null;
      this.rating = rating || null;
      this.holiday = holiday || null;

      const bq = this.$route.query;

      // Orden de un link compartido
      const sortCompartido = this.listSort.find((l) => String(l.id) === String(bq.sort));
      if (sortCompartido) setSortWeeksObject(sortCompartido);

      // Viene de la ficha de una semana que ya no existe (Resort.vue)
      if (bq.noDisponible) this.avisoNoDisponible = bq.noDisponible;

      // Los parámetros ya quedaron en searchWeek: se quitan de la URL para que un
      // recargo no pise los filtros que el socio cambie después
      const restQuery = { ...bq };
      let quitar = false;
      for (const param of [...PARAMS_COMPARTIBLES, "noDisponible"]) {
        if (param in restQuery) {
          delete restQuery[param];
          quitar = true;
        }
      }
      if (quitar) this.$router.replace({ query: restQuery }).catch(() => {});
    },
    // Destino, fechas y filtros en texto, para el resumen de la ventana de compartir
    resumenBusqueda() {
      const lugar = this.city === "all" ? this.$func.parseIso("allCity") : this.city;
      const destino = [lugar, this.state, this.country].filter(Boolean).join(", ");
      const lista = (v) => (Array.isArray(v) ? v.join(", ") : v);
      const filtros = [
        lista(this.weekType),
        lista(this.capacity),
        lista(this.kitchen),
        this.occupancy ? `${lista(this.occupancy)} guests` : null,
        this.priceMin != null || this.priceMax != null
          ? `$${this.priceMin ?? 0} - ${this.priceMax != null ? `$${this.priceMax}` : "+"}`
          : null,
        this.rating,
        this.cityFilter,
        this.selectSort ? this.$func.parseIso(this.selectSort.nameIso) : null,
      ].filter(Boolean);
      return [
        destino,
        `${this.formatNate(this.checkIn)} - ${this.formatNate(this.checkOut)}`,
        filtros.length ? `${this.$func.parseIso("shareFilters")}: ${filtros.join(" · ")}` : null,
      ];
    },
    busquedaActual() {
      return {
        country: this.country,
        state: this.state,
        city: this.city,
        checkIn: this.checkIn,
        checkOut: this.checkOut,
        type: this.weekType,
        capacity: this.capacity,
        occupancy: this.occupancy,
        kitchen: this.kitchen,
        resort: this.resort,
        cityFilter: this.cityFilter,
        priceMin: this.priceMin,
        priceMax: this.priceMax,
        rating: this.rating,
        holiday: this.holiday,
      };
    },
    compartirBusqueda() {
      this.$bus.emit("open-share-link", {
        titulo: this.$func.parseIso("shareSearchTitle"),
        resumen: this.resumenBusqueda(),
        link: linkBusqueda(this.busquedaActual(), { sortId: this.selectSort?.id }),
      });
    },
    async listWeeks() {
      if (this.country && this.city && this.checkIn && this.checkOut) {
        try {
          let payload = {
            country: this.country,
            city: this.cityFilter || this.city,
            dateIn: this.checkIn,
            dateOut: this.checkOut,
          };
          if (this.state) payload.state = this.state;

          if (this.selectSort) payload.sort = this.selectSort.value;

          /**
           * Filtros
           */
          if (this.weekType) payload.InvTypeInDetail = this.weekType;
          if (this.occupancy) payload.MaxOccupancy = this.occupancy;
          if (this.capacity) payload.UnitType = this.capacity;
          if (this.kitchen) payload.KitchenType = this.kitchen;
          if (this.resort) payload.ResortName = this.resort;
          if (this.priceMin != null) {
            payload.PrecioMin = parseFloat(this.priceMin);
          }
          if (this.priceMax != null) {
            payload.PrecioMax = parseFloat(this.priceMax);
          }
          if (this.rating) {
            payload.Rating = this.rating;
          }
          if (this.holiday && this.holiday.length) {
            payload.HolidayFilter = optionTokens(this.holiday);
          }

          const { data } = await this.$axios.post(
            `/week/list?limit=${this.limit}&page=${this.page}&isPaginate=s`,
            {
              ...payload,
            },
          );
          this.weeks = data.weeks;
          this.totalPage = data.paginate.totalPages;
          this.totalList = data.paginate.total;
          this.checkFilters = data?.filters || null;

          this.loading = false;
          // console.log("this.totalPage listWeeks", this.totalPage);
          this.$bus.emit("refresh-page", this.totalPage);
          this.$bus.emit("refresh-filters", this.checkFilters);
          // console.log(this.countries);
        } catch (error) {
          console.log(error);
        }
      } else this.$router.push("/");
    },
    async checkSesion() {
      try {
        const { token } = this.$route.query;

        if (!token) {
          const urllogin = localStorage.getItem("UrlLogin");
          // console.log('urllogin', urllogin)
          // console.log(`https://${process.env.VUE_APP_URL_LOGIN_DEFAULT}`)
          if (urllogin) window.location.href = `https://${urllogin}`;
          else
            window.location.href = `https://${process.env.VUE_APP_URL_LOGIN_DEFAULT}`;
        }

        this.token = token;

        const { data } = await this.$axios.get(`/auth/sesion?token=${token}`);
        if (data.success) {
          this.$bus.emit("sesion", { sesion: data.sesion, data: data.data });
          if (data?.data?.club) this.club = data?.data?.club;
        } else {
          if (data.sesion)
            window.location.href = `https://${data.sesion.UrlLogin}`;
          else
            window.location.href = `https://${process.env.VUE_APP_URL_LOGIN_DEFAULT}`;
        }
        // console.log(this.countries);
      } catch (error) {
        console.log(error);
      }
    },
    setSort(id, execListWeeks = false) {
      console.log("setSort", id);
      const sort = this.listSort.find((l) => l.id === id);
      this.selectSort = sort;
      this.openListSort = false;
      setSortWeeksObject(sort);
      if (execListWeeks) {
        this.loading = true;
        this.listWeeks();
      }
    },
    openFiltersTab() {
      this.$bus.emit("open-filters");
    },
  },
};
</script>

<style scoped>
.rbar {
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 14px;
}
.rcnt {
  font-size: 13px;
  color: #6b7280;
  flex: 1;
  min-width: 0;
}
.rcnt strong {
  color: #00527c;
  font-weight: 700;
}
.sort-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}
.share-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1.5px solid #0472aa;
  border-radius: 6px;
  background: #fff;
  color: #00527c;
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}
.share-btn:hover {
  background: #eaf4fa;
}
.share-btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.aviso-no-disponible {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #7c2d12;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 14px;
}
.sort-lbl {
  font-size: 11px;
  color: #b0b8c1;
  font-weight: 600;
}
.sort-sel {
  padding: 6px 10px;
  border: 1.5px solid #dde3ea;
  border-radius: 6px;
  font-size: 12px;
  color: #1a1a2e;
  background: #fff;
  font-family: inherit;
  outline: none;
  cursor: pointer;
}

@media (max-width: 767px) {
  .rbar {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .sort-wrap {
    margin-left: 0;
    justify-content: center;
    flex-wrap: wrap;
    flex-shrink: 1;
    width: 100%;
  }
  .share-btn {
    width: 100%;
    justify-content: center;
    padding: 9px 12px;
  }
}

:root {
  --s-color-brand-primary: #0472aa;
  --s-color-brand-primary-hsl-hue: 200;
  --s-color-brand-primary-hsl-saturation: 95%;
  --s-color-brand-primary-hsl-light: 34%;
  --s-color-brand-primary-red: 4;
  --s-color-brand-primary-green: 114;
  --s-color-brand-primary-blue: 170;

  --s-color-brand-dark: #00527c;
  --s-color-brand-dark-hsl-hue: 200;
  --s-color-brand-dark-hsl-saturation: 100%;
  --s-color-brand-dark-hsl-light: 24%;
  --s-color-brand-dark-red: 0;
  --s-color-brand-dark-green: 82;
  --s-color-brand-dark-blue: 124;

  --s-color-searchbox-background: #00527c;
  --s-color-searchbox-background-hsl-hue: 200;
  --s-color-searchbox-background-hsl-saturation: 100%;
  --s-color-searchbox-background-hsl-light: 24%;
  --s-color-searchbox-background-red: 0;
  --s-color-searchbox-background-green: 82;
  --s-color-searchbox-background-blue: 124;

  --s-color-searchbox-text: #393939;
  --s-color-searchbox-text-hsl-hue: 0;
  --s-color-searchbox-text-hsl-saturation: 0%;
  --s-color-searchbox-text-hsl-light: 22%;
  --s-color-searchbox-text-red: 57;
  --s-color-searchbox-text-green: 57;
  --s-color-searchbox-text-blue: 57;

  --s-color-footer-background: #00527c;
  --s-color-footer-background-hsl-hue: 200;
  --s-color-footer-background-hsl-saturation: 100%;
  --s-color-footer-background-hsl-light: 24%;
  --s-color-footer-background-red: 0;
  --s-color-footer-background-green: 82;
  --s-color-footer-background-blue: 124;

  --s-color-footer-text: #393939;
  --s-color-footer-text-hsl-hue: 0;
  --s-color-footer-text-hsl-saturation: 0%;
  --s-color-footer-text-hsl-light: 22%;
  --s-color-footer-text-red: 57;
  --s-color-footer-text-green: 57;
  --s-color-footer-text-blue: 57;
}

.noIcon {
  background: none;
}

.c-sb-input__field {
  padding-left: 40px;
}

.edit-search-modal {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.edit-search-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #eef2f6;
}
.edit-search-modal__title {
  font-weight: 600;
  color: #1a1a2e;
}
.edit-search-modal__close {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #6b7280;
}
.edit-search-modal__close:hover {
  color: #1a1a2e;
}
.edit-search-modal__body {
  padding: 8px 4px;
  max-height: 70vh;
  overflow-y: auto;
}
</style>
